import firebase from './firebaseBundle'

const getPendingCredentialFromSessionStorage = () => {
  const pendingCredentialFromSessionStorage = JSON.parse(window.sessionStorage.getItem('anova_pending_credential'))

  if (pendingCredentialFromSessionStorage) {
    if (pendingCredentialFromSessionStorage.providerId === 'google.com') {
      return firebase.auth.GoogleAuthProvider.credential(pendingCredentialFromSessionStorage.accessToken)
    } else if (pendingCredentialFromSessionStorage.providerId === 'facebook.com') {
      return firebase.auth.FacebookAuthProvider.credential(pendingCredentialFromSessionStorage.accessToken)
    }
  }

  return null
}

export default getPendingCredentialFromSessionStorage
